import { useAppStore } from '@/store/useAppStore.ts'
import { getChemistryPreset } from '@brt/shared-logic'

export default function PeukertInfo() {
  const chemistry = useAppStore((s) => s.battery.chemistry)
  const preset = getChemistryPreset(chemistry)
  const exponent = preset.peukertExponent

  const getDescription = (exp: number): string => {
    if (exp === 1.0) return 'No Peukert effect — capacity is independent of discharge rate'
    if (exp <= 1.05) return 'Minimal effect — slight capacity reduction at high discharge rates'
    if (exp <= 1.15) return 'Moderate effect — capacity reduces noticeably at high discharge rates'
    return 'Significant effect — high discharge rates substantially reduce usable capacity'
  }

  return (
    <div className="peukert-info">
      <div className="peukert-info__header">
        <span className="peukert-info__title">Peukert Exponent</span>
        <span className="peukert-info__value">{exponent.toFixed(2)}</span>
      </div>
      <p className="peukert-info__description">{getDescription(exponent)}</p>
      {exponent > 1.0 && (
        <p className="peukert-info__detail">
          At 2× rated load, effective capacity ≈ {((1 / Math.pow(2, exponent - 1)) * 100).toFixed(0)}% of rated
        </p>
      )}
    </div>
  )
}
